<template>
  <div class="general-info-pg">
    <div class="main-card">
      <div v-if="productImage" class="img-container" :style="{'background-image': `url(${productImage})`}"></div>
      <div>
        <div id="main-title">
          <h1 class="main-title">{{ productTitle }}</h1>
        </div>
        <div id="sub-title">
          <h2 class="sub-title">See your personalized size recommendation</h2>
        </div>
      </div>
    </div>

    <progress-bar/>

    <div id="input-form" class="input-form">
      <div class="form-group no-mt">
        <span class="form-control-label">Gender</span>
        <div class="form-input">
          <gender-dropdown v-model="$v.gender.$model" :invalid="$v.gender.$error"/>

          <div class="input-error" v-if="!$v.gender.required && $v.gender.$dirty">Gender is required</div>
        </div>
      </div>

      <div class="form-group">
        <span class="form-control-label">Height</span>
        <div class="row form-input">
          <height-input/>
          <unit-system-toggle/>
        </div>
      </div>

      <div class="form-group">
        <span class="form-control-label">Weight</span>
        <div class="row form-input">
          <weight-input/>
        </div>
      </div>
    </div>

    <navigation prev-hide/>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import Navigation from "../../Navigation";
import GenderDropdown from "../../form/GenderDropdown";
import {validationMixin} from 'vuelidate';
import {required, numeric, between} from 'vuelidate/lib/validators';
import {mapFields} from 'vuex-map-fields';
import {mapGetters} from 'vuex';
import HeightInput from "../../form/HeightInput";
import WeightInput from "../../form/WeightInput";
import UnitSystemToggle from "../../form/UnitSystemToggle";

export default {
  name: "GeneralInfoView",

  mixins: [validationMixin],

  provide() {
    return {
      $v: this.$v,
    };
  },

  components: {UnitSystemToggle, WeightInput, HeightInput, GenderDropdown, Navigation, ProgressBar},

  computed: {
    ...mapGetters({
      unitSystem: 'userSelections/getUnitSystem',
      productTitle: 'shopify/product/title',
      productImage: 'shopify/product/image',
    }),

    ...mapFields('userSelections', {
      gender: 'general.gender',
      weight: 'general.weight',
      heightMetric: 'general.height.metric',
      heightImperialFeet: 'general.height.imperial.feet',
      heightImperialInch: 'general.height.imperial.inch',
    }),
  },

  watch: {
    unitSystem() {
      this.heightMetric = null;
      this.heightImperialFeet = null;
      this.heightImperialInch = null;
      this.weight = '';
      this.$v.$reset();
    },
  },

  methods: {
    submit() {
      return new Promise(resolve => {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          resolve();
        }
      });
    },
  },

  validations() {
    if (this.unitSystem === 'imperial') {
      return {
        gender: {required},
        heightImperialFeet: {required, numeric, between: between(3, 7)},
        heightImperialInch: {required, numeric, between: between(0, 11)},
        heightMetric: {},
        weight: {required, numeric, between: between(55, 441)},
      };
    }

    return {
      gender: {required},
      heightImperialFeet: {},
      heightImperialInch: {},
      heightMetric: {required, numeric, between: between(90, 230)},
      weight: {required, numeric, between: between(25, 200)},
    };
  },
};
</script>
